<template>
  <div class="products-and-offers-container">
    <div class="import-and-search-section" :class="importOffersClass">
      <slot name="import-and-search-content" />
    </div>
    <div class="selected-products-section">
      <selected-products
        :disabled="disabled"
        :clear-all="clearAll"
        :initially-products="initiallyProducts"
        @set-item="setItem"
        @remove-group="removeGroup"
        @remove-item="removeItem"
        @search-item="querySelections"
      />
    </div>
  </div>
</template>

<script>
import SelectedProducts from './SelectedProducts.vue'

export default {
  name: 'ProductsAndOffersContainer',
  components: {
    SelectedProducts,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
    querySelections: {
      type: Function,
    },
    setItem: {
      type: Function,
    },
    removeGroup: {
      type: Function,
    },
    removeItem: {
      type: Function,
    },
    clearAll: {
      type: Function,
    },
    initiallyProducts: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    products: [],
    searchedItems: [],
    productsGroups: [],
    importRequiredAnyOfFields: ['sku', 'ean'],
    importFields: [
      { text: 'SKU', value: 'sku' },
      { text: 'EAN', value: 'ean' },
      { text: 'Nome', value: 'name' },
      { text: 'Preço 1', value: 'price_1' },
      { text: 'Preço 2', value: 'price_2' },
    ],
  }),
  computed: {
    importOffersClass() {
      const tab = this.hasOfferSalesPermission ? 1 : 0
      return tab === 1 ? 'align-content-center' : ''
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.products-and-offers-container {
  display: flex;
  flex-direction: row;

  .import-and-search-section {
    max-height: 100%;
    width: 65%;
  }

  .selected-products-section {
    width: 35%;
    border-left: 1px solid $cinza-l60;
    padding: 12px;
    overflow-y: auto;
    overflow-x: none;
    max-height: 600px;
  }
}
</style>
